import React from 'react';

export default function HorseHornsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="25.21,38.0 10.89,38.0 15.44,25.09 29.76,25.09" fill="#E6DCE6" />
      <polygon points="12.41,13.45 26.72,13.45 29.76,25.09 15.44,25.09" fill="#FFFFFF" opacity="0.92" />
      <polygon points="10.89,38.0 7.85,26.36 12.41,13.45 15.44,25.09" fill="#BBA0BB" opacity="0.95" />
      <polygon points="27.59,23.64 16.85,23.64 21.41,10.73 32.15,10.73" fill="#E6DCE6" />
      <polygon points="19.13,2.0 29.87,2.0 32.15,10.73 21.41,10.73" fill="#FFFFFF" opacity="0.92" />
      <polygon points="16.85,23.64 14.58,14.91 19.13,2.0 21.41,10.73" fill="#BBA0BB" opacity="0.95" />
    </svg>
  );
}
